import { render, staticRenderFns } from "./jggdmx.vue?vue&type=template&id=08e66a86&scoped=true"
import script from "./jggdmx.vue?vue&type=script&lang=js"
export * from "./jggdmx.vue?vue&type=script&lang=js"
import style0 from "./jggdmx.vue?vue&type=style&index=0&id=08e66a86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e66a86",
  null
  
)

export default component.exports